import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-[45px]" }
const _hoisted_2 = { class: "w-full mb-[45px] px-8" }
const _hoisted_3 = { class: "w-full flex flex-col items-start gap-3" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "w-full flex items-center justify-between pt-3 border-t border-black/15" }
const _hoisted_8 = { class: "w-full h-full" }


import QuestionnareButtonColor from "../parts/QuestionnareButtonColor.vue";
import QuestionnaireButtonPrev from "../parts/QuestionnaireButtonPrev.vue";
import QuestionnaireOutline from "../parts/QuestionnaireOutline.vue";

type Props = {
  appointmentCompletedButtonText: string;
  dataIsMissingButtonText: string;
  apointmentFailedButtonText: string;
  prevButtonText: string;
};

type Emits = {
  (event: "onSubmit", value: boolean, message: string): void;
  (event: "onAbnahmePassed"): void;
  (event: "onDataMissing"): void;
  (event: "onAbnahmeFailed"): void;
  (event: "onStepBack"): void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'AbnahmeApointmentCompleted',
  props: {
    appointmentCompletedButtonText: {},
    dataIsMissingButtonText: {},
    apointmentFailedButtonText: {},
    prevButtonText: {}
  },
  emits: ["onSubmit", "onAbnahmePassed", "onDataMissing", "onAbnahmeFailed", "onStepBack"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-xl leading-[32px] tracking-[0.01rem] text-primary-text-color font-semibold pb-2" }, " What is the outcome of Abnahme? ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(QuestionnareButtonColor, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onAbnahmePassed'))),
            "button-text": __props.appointmentCompletedButtonText
          }, null, 8, ["button-text"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(QuestionnaireOutline, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onDataMissing'))),
            "button-text": __props.dataIsMissingButtonText
          }, null, 8, ["button-text"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(QuestionnaireOutline, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onAbnahmeFailed'))),
            "button-text": __props.apointmentFailedButtonText
          }, null, 8, ["button-text"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(QuestionnaireButtonPrev, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onStepBack'))),
          "button-text": __props.prevButtonText
        }, null, 8, ["button-text"])
      ])
    ])
  ]))
}
}

})